import { CustomElement } from '@aurelia/runtime-html';
export const name = "spinner";
export const template = "<template>\n  <span show.bind=\"busy\">\n    <i class=\"fas fa-spinner fa-spin\"></i>\n  </span>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
